/**
 * 记录页面停留时间
 */
import event from "./event";
let stayTimer = true;
let $pageRunTime = {};
let clearId = null;

function startPageTimer(router) {
  clearId = window.setInterval(() => {
    if (stayTimer) {
      let record = $pageRunTime?.[router.path]?.record;
      let current = record[record.length - 1];
      current.time += 1000;
    }
  }, 1000);
}
function endPageTimer(router) {
  clearId && window.clearInterval(clearId);
  clearId = null;
}
function updataPageTimer(to, from, callback) {
  if (to && to.path != "/") {
    if (dsf.isUnDef($pageRunTime[to.path])) {
      $pageRunTime[to.path] = {
        name: to.meta.title,
        record: []
      };
    }
    $pageRunTime[to.path].record.push({
      time: 0
    });
  }
  if (to.path != from.path) {
    endPageTimer(from);
    startPageTimer(to);
  }
}

event.addVisiblityChangeEvent(() => {
  if (document.visibilityState == "hidden") {
    stayTimer = false;
  } else if (document.visibilityState == "visible") {
    stayTimer = true;
  }
});

export default {
  start: updataPageTimer,
  record: $pageRunTime
};
